import {useQuery} from 'react-query'
import {OperatorEditModalForm} from './OperatorEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getOperatorsFilter} from '../core/_requests'
import { OperatorStatus } from '../core/_models'
import {useAuth} from '../../../../auth/core/Auth'

const OperatorEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {currentUser} = useAuth()

  const {
    isLoading,
    data: operator,
    error,
    status
  } = useQuery(
    `${QUERIES.OPERATORS_LIST}-operator-${itemIdForUpdate}`,
    () => {
      return getOperatorsFilter(currentUser?.last_company_id, {id: itemIdForUpdate, take: 0, skip: 1})
    },
    {
      cacheTime: 0,
      refetchOnWindowFocus: false,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return (
      <OperatorEditModalForm
        isOperatorLoading={isLoading}
        response={{
          status_id: OperatorStatus.active.id,
          created_at: new Date(),
        }}
        status={status}
      />
    )
  }

  if (!isLoading && !error && operator) {
    return (
      <OperatorEditModalForm
      isOperatorLoading={isLoading}
        response={operator?.data}
        status={status}
      />
    )
  }

  return null
}

export {OperatorEditModalFormWrapper}
